import React, { Component } from "react";
import {
  company,
  loading,
  float,
  NavbarWarehouse,
  Pagination,
  Modal,
  alert,
  GET,
  POST,
  PUT,
  DELETE,
  t,
} from "../../components/CustomComponent.js";

const TYPE = [
  "zone",
  "row",
  "rack",
  "room",
  "other",
]
export default class LocationManagement extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filter_search: "",
      filter_type: "",
      filter_status: "",

      modal_create: false,
      modal_update: false,
      count: 0,

      // Form States (Modal)
      uid: "",
      company_id: company?.id || "", // Default company_id
      location_code: "",
      location_type: "",
      name: "",
      description: "",
      address: "",
      latitude: "",
      longitude: "",
      is_active: "Active",

      // List Data
      data: [],
      data_locations: [],
    };
  }

  async componentDidMount() {
    loading(false);
    this.Get(1);
  }

  Get = async (page) => {
    const { filter_search } = this.state;
    let data, count, data_locations;
    loading(true);

    // Call GET API Locations
    let [result, result_locations] = await Promise.all([
      GET("warehouse/locations", {
        page_size: 10,
        page: page,
        data_search: filter_search || "",
        location_type: this.state.filter_type || "",
        is_active: this.state.filter_status || "",
      }),
      GET("warehouse/locations", {
        page_size: 100000,
        page: 0,
        data_search: filter_search || "",
        location_type: this.state.filter_type || "",
        is_active: this.state.filter_status || "",
      })
    ]);

    if (result?.status) {
      data = result.data;
      count = result.pagination?.count || 0;
    }

    if (result_locations?.status) {
      data_locations = result_locations.data;
    }

    this.setState({ data: data || [], count, data_locations: data_locations || [] });
    loading(false);
  };

  CreateUpdate = async () => {
    const {
      uid,
      company_id,
      location_code,
      location_type,
      name,
      description,
      address,
      latitude,
      longitude,
      is_active,
    } = this.state;

    // Validation
    if (!location_code.trim()) {
      alert("", "warning", t("warning"), t("verify_location_code"));
      return;
    } else if (!name.trim()) {
      alert("", "warning", t("warning"), t("verify_location_name"));
      return;
    } else if (!location_type.trim()) {
      alert("", "warning", t("warning"), t("verify_location_type"));
      return;
    }

    if (
      await alert(
        "",
        "info",
        t("confirm"),
        t("confirm_submission"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      
      // Request Body
      let body = {
        company_id,
        location_code,
        location_type,
        name,
        description,
        address,
        latitude: latitude ? String(latitude) : "",
        longitude: longitude ? String(longitude) : "",
        is_active: is_active === "Active",
      };

      // Call API
      let result = !uid
        ? await POST("warehouse/locations", body)
        : await PUT("warehouse/locations/" + uid, body);

      if (result?.status === true) {
        alert("#", "success");
        this.setState({ modal_create: false, modal_update: false }, () => {
            this.Get(1); // Refresh data
        });
      } else {
        alert(
          "",
          "warning",
          t("warning"),
          result?.message || t("error_occurred"),
        );
      }
      loading(false);
    }
  };

  Delete = async (id) => {
    if (
      await alert(
        "",
        "warning",
        t("delete_item"),
        t("delete_desc"),
        t("confirm"),
        t("cancel"),
      )
    ) {
      loading(true);
      let result = await DELETE("warehouse/locations/" + id, null);
      if (result?.status) {
        alert("#", "success");
        this.Get(1); // Refresh data after delete
      }
      loading(false);
    }
  };

  resetForm = () => {
    this.setState({
      uid: "",
      location_code: "",
      location_type: "",
      name: "",
      description: "",
      address: "",
      latitude: "",
      longitude: "",
      is_active: "Active",
    });
  };

  render() {
    const {
      data,
      data_locations,
      count,
      filter_search,
      filter_type,
      filter_status,
      modal_create,
      modal_update,
      location_code,
      location_type,
      name,
      description,
      address,
      latitude,
      longitude,
      is_active,
    } = this.state;

    return (
        <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
            <NavbarWarehouse />
            <div className="body p-4 mt-3">
                {/* Header Section */}
                <div className="d-flex flex-wrap justify-content-between align-items-center mb-4 gap-3">
                    <div>
                        <h3 className="fw-bold mb-1 text-dark">{t("location_management")}</h3>
                        <div className="text-secondary text-14">{t("manage_locations_desc")}</div>
                    </div>
                </div>

                {/* Top KPI Cards */}
                <div className="row g-3 mb-4">
                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("total_locations")}</div>
                                    <h4 className="fw-bold text-dark mb-0">{data_locations.length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">
                                    {"\uf041"} {/* Map Marker icon */}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("active_locations")}</div>
                                    <h4 className="fw-bold text-success mb-0">{data_locations.filter((d) => d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf4fc"}</div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6">
                        <div className="card border-0 rounded-4 shadow-sm p-3 h-100">
                            <div className="d-flex align-items-center justify-content-between">
                                <div>
                                    <div className="text-secondary text-12 mb-1">{t("inactive_locations")}</div>
                                    <h4 className="fw-bold text-secondary mb-0">{data_locations.filter((d) => !d.is_active).length}</h4>
                                </div>
                                <div className="wpx-40 hpx-40 rounded bg-light text-secondary border d-flex align-items-center justify-content-center text-18 icon">{"\uf4fa"}</div>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Main White Container */}
                <div className="bg-white rounded-4 shadow-sm p-4 mb-4">
                    {/* Top Filter Toolbar */}
                    <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div className="d-flex gap-2 flex-wrap">
                            <div className="position-relative" style={{ maxWidth: "300px", width: "100%" }}>
                                <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
                                <input
                                    type="text"
                                    className="form-control ps-5 wpx-300"
                                    style={{ height: "38px" }}
                                    placeholder={t("search_locations")}
                                    value={filter_search}
                                    onChange={(e) => this.setState({ filter_search: e.target.value })}
                                />
                            </div>
                            <select className="form-select wpx-150" value={filter_type} onChange={(e) => this.setState({ filter_type: e.target.value })}>
                                <option value="">{t("all_types")}</option>
                                {TYPE.map((type, idx) => (
                                    <option key={idx} value={type}>
                                        {t(type)}
                                    </option>
                                ))}
                            </select>
                            <select className="form-select wpx-150" value={filter_status} onChange={(e) => this.setState({ filter_status: e.target.value })}>
                                <option value="">{t("all_status")}</option>
                                <option value="true">{t("active")}</option>
                                <option value="false">{t("inactive")}</option>
                            </select>
                            <div className="d-flex gap-2">
                                <button className="btn btn-secondary px-3 py-2 fw-bold rounded-3 shadow-sm" onClick={() => this.Get(1)}>
                                    {t("filter")}
                                </button>
                                <button
                                    className="btn btn-white border px-3 py-2 fw-bold rounded-3 shadow-sm"
                                    onClick={() => this.setState({ filter_search: "", filter_status: "", filter_type: "" }, () => this.Get(1))}
                                >
                                    {t("clear_all")}
                                </button>
                            </div>
                        </div>
                        <button
                            className="btn btn-primary px-3 py-2 fw-bold rounded-3 shadow-sm d-flex align-items-center"
                            onClick={() => {
                                this.resetForm();
                                this.setState({ modal_create: true });
                            }}
                        >
                            <span className="me-2 text-16">+</span> {t("add_location")}
                        </button>
                    </div>
                </div>

                <div className="bg-white rounded-4 shadow-sm mb-4 overflow-hidden">
                    {/* Locations Table */}
                    <div className="table-responsive">
                        <table className="table table-hover align-middle mb-0" style={{ minWidth: "1000px" }}>
                            <thead>
                                <tr className="text-dark fw-bold text-12 border-bottom border-light">
                                    <th className="py-3 border-0">{t("location")}</th>
                                    <th className="py-3 border-0">{t("warehouse")}</th>
                                    <th className="py-3 border-0">{t("type")}</th>
                                    <th className="py-3 border-0">{t("address")}</th>
                                    <th className="py-3 border-0 text-center">{t("status")}</th>
                                    <th className="py-3 border-0 text-center">{t("actions")}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((item, idx) => (
                                    <tr key={idx} className="border-bottom border-light bg-white">
                                        {/* Location Info */}
                                        <td className="py-3">
                                            <div className="d-flex align-items-center">
                                                <div
                                                    className={`wpx-35 hpx-35 rounded-circle text-white d-flex align-items-center justify-content-center me-3 flex-shrink-0 fw-bold text-12 bg-primary`}
                                                >
                                                    <span className="icon">{"\uf041"}</span>
                                                </div>
                                                <div>
                                                    <div className="fw-bold text-dark text-14">{item.name}</div>
                                                    <div className="text-secondary text-10">
                                                        {t("code")}: {item.location_code}
                                                    </div>
                                                </div>
                                            </div>
                                        </td>

                                        {/* Warehouse */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "200px" }}>
                                                {item.warehouse?.name || "-"}
                                            </div>
                                        </td>
                                        {/* Type */}
                                        <td>
                                            <span className={`badge bg-primary-light text-primary rounded-pill px-2 py-1 fw-bold text-10 border border-primary`}>
                                                {item.location_type ? t(item.location_type) : "-"}
                                            </span>
                                        </td>

                                        {/* Address */}
                                        <td>
                                            <div className="text-secondary text-14 text-truncate" style={{ maxWidth: "200px" }}>
                                                {item.address || "-"}
                                            </div>
                                        </td>

                                        {/* Status */}
                                        <td className="text-center">
                                            {item.is_active ? (
                                                <span className="text-success text-12 fw-bold bg-success-light px-2 py-1 rounded-pill">{t("active")}</span>
                                            ) : (
                                                <span className="text-secondary text-12 fw-bold bg-light px-2 py-1 rounded-pill border">{t("inactive")}</span>
                                            )}
                                        </td>

                                        {/* Actions */}
                                        <td className="text-center">
                                            <div className="d-flex justify-content-center gap-3 text-16">
                                                <span
                                                    className="icon text-primary pointer hover-primary transition-hover"
                                                    onClick={() => {
                                                        this.setState({
                                                            modal_update: true,
                                                            ...item,
                                                            is_active: item.is_active ? "Active" : "Inactive",
                                                        });
                                                    }}
                                                >
                                                    {"\uf044"}
                                                </span>
                                                <span
                                                    className="icon text-danger pointer hover-danger transition-hover"
                                                    onClick={() => {
                                                        this.Delete(item.uid);
                                                    }}
                                                >
                                                    {"\uf2ed"}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>

                {/* Footer Pagination */}
                <div className="d-flex justify-content-between align-items-center mt-4 flex-wrap text-secondary text-12">
                    <div>
                        {t("showing")} {data.length > 0 ? 1 : 0}-{data.length} {t("of")} {count} {t("locations_count")}
                    </div>
                    <Pagination className="mb-0" count={Math.ceil(count / 10) || 1} showFirstButton={false} showLastButton={false} onChange={(_, page) => this.Get(page)} />
                </div>
            </div>

            {/* MODAL: ADD/EDIT LOCATION */}
            <Modal
                size="lg"
                show={modal_create || modal_update}
                onHide={() => this.setState({ modal_create: false, modal_update: false })}
                centered
                contentClassName="border-0 rounded-4 overflow-hidden shadow-lg"
            >
                <Modal.Header className="border-bottom border-light px-4 py-3 bg-white" closeButton>
                    <h5 className="fw-bold mb-0 text-dark">{modal_update ? t("edit_location") : t("add_new_location")}</h5>
                </Modal.Header>
                <Modal.Body className="p-4 bg-white">
                    <div className="row g-4">
                        {/* Basic Information */}
                        <div className="col-12">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf05a"}</span> {t("basic_information")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("location_basic_info_desc")}</small>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("location_code")} <span className="text-danger">*</span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="e.g. L-001"
                                        value={location_code}
                                        onChange={(e) => this.setState({ location_code: e.target.value })}
                                        disabled={modal_update}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("location_name")} <span className="text-danger">*</span>
                                    </label>
                                    <input type="text" className="form-control py-2" placeholder="e.g. Zone-01" value={name} onChange={(e) => this.setState({ name: e.target.value })} />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">
                                        {t("location_type")} <span className="text-danger">*</span>
                                    </label>
                                    <select className="form-select py-2" value={location_type} onChange={(e) => this.setState({ location_type: e.target.value })}>
                                        <option value="">{t("select_type")}</option>
                                        {TYPE.map((type, idx) => (
                                            <option key={idx} value={type}>
                                                {t(type)}
                                            </option>
                                        ))}
                                        {location_type && !TYPE.includes(location_type) && (
                                            <option value={location_type}>{t(location_type)}</option>
                                        )}
                                    </select>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">{t("address")}</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder={t("address_placeholder")}
                                        value={address}
                                        onChange={(e) => this.setState({ address: e.target.value })}
                                    />
                                </div>

                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">{t("latitude")}</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="e.g. 18.8300264"
                                        value={latitude}
                                        onChange={(e) => {
                                            if (!float(e.target.value) && e.target.value !== "" && e.target.value !== "-") return;
                                            this.setState({ latitude: e.target.value });
                                        }}
                                    />
                                </div>
                                <div className="col-md-6">
                                    <label className="form-label text-14 text-dark mb-2">{t("longitude")}</label>
                                    <input
                                        type="text"
                                        className="form-control py-2"
                                        placeholder="e.g. 99.0460351"
                                        value={longitude}
                                        onChange={(e) => {
                                            if (!float(e.target.value) && e.target.value !== "" && e.target.value !== "-") return;
                                            this.setState({ longitude: e.target.value });
                                        }}
                                    />
                                </div>

                                <div className="col-12">
                                    <label className="form-label text-14 text-dark mb-2">{t("description")}</label>
                                    <textarea
                                        className="form-control py-2"
                                        rows="2"
                                        placeholder={t("location_description")}
                                        value={description}
                                        onChange={(e) => this.setState({ description: e.target.value })}
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Status */}
                        <div className="col-12 mt-4 border-top pt-4">
                            <h6 className="fw-bold mb-1 d-flex align-items-center">
                                <span className="icon text-primary me-2">{"\uf772"}</span> {t("status")}
                            </h6>
                            <small className="text-muted d-block mb-3">{t("status_desc")}</small>
                            <div className="d-flex gap-4">
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="locationStatus"
                                        id="statusActive"
                                        checked={is_active === "Active"}
                                        onChange={() => this.setState({ is_active: "Active" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusActive">
                                        {t("active")}
                                    </label>
                                </div>
                                <div className="form-check d-flex align-items-center gap-2">
                                    <input
                                        className="form-check-input mt-0 pointer"
                                        type="radio"
                                        name="locationStatus"
                                        id="statusInactive"
                                        checked={is_active === "Inactive"}
                                        onChange={() => this.setState({ is_active: "Inactive" })}
                                    />
                                    <label className="form-check-label text-dark text-14 pointer" htmlFor="statusInactive">
                                        {t("inactive")}
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer className="border-top border-light px-4 py-3 bg-white d-flex justify-content-end gap-2">
                    <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={() => this.setState({ modal_create: false, modal_update: false })}>
                        {t("cancel")}
                    </button>
                    <button
                        className="btn btn-primary px-4 py-2 d-flex align-items-center rounded-3 fw-bold text-white shadow-sm"
                        style={{ backgroundColor: "#2563eb", borderColor: "#2563eb" }}
                        onClick={() => {
                            this.CreateUpdate();
                        }}
                    >
                        <span className="icon me-2">{"\uf0c7"}</span> {t("save")}
                    </button>
                </Modal.Footer>
            </Modal>
        </div>
    );
  }
}